'use strict';

window.COLOR_DEFAULT_DRAW_POLYGON = '#1BE4D3';
window.DRAW_POLYGON_OPTIONS = {
  editable: false,
  clickable: true,
  draggable: false,
  strokeColor: COLOR_DEFAULT_DRAW_POLYGON,
  strokeOpacity: 1,
  strokeWeight: 2,
  fillColor: COLOR_DEFAULT_DRAW_POLYGON,
  fillOpacity: 0.8
};

window.DRAW_POLYGON_OPTIONS_LEAFLET = {
  draggable: false,
  color: COLOR_DEFAULT_DRAW_POLYGON,
  strokeWeight: 2,
  opacity: 0.8
};

window.DRAW_POLYGON_OPTIONS_DRAGGABLE = {
  editable: true,
  clickable: true,
  draggable: true,
  strokeColor: COLOR_DEFAULT_DRAW_POLYGON,
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: COLOR_DEFAULT_DRAW_POLYGON,
  fillOpacity: 0.5
};

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('DrawPolygonsService', function($http, RestService, DrawPolygonsObjectService) {
  return {
    // eslint-disable-next-line complexity
    list: function(filters) {
      const insumo = (filters.cultivar || {}).id || [];
      const params = !filters ? {} : {
        page: filters.page || null,
        safra: (filters.safra || {}).id || null,
        gleba: (filters.gleba || {}).id || null,
        atividade: (filters.atividade || {}).id || null,
        tp_insumo: insumo[0] || null,
        cd_insumo: insumo[1] || null,
        descricao: filters.descricao || null,
        tipo: (filters.tipo || {}).id || null,
        operacao: (filters.operacao || {}).id || null,
        maquina: (filters.maquina || {}).id || null,
        propriedade: (filters.propriedade || {}).id || null,
        somente_carregar_automaticamente: !!filters.somente_carregar_automaticamente,
        favorites: filters.favorites,
        complete: !!filters.complete || null
      };

      return RestService.getFromUrl(`${SERVER + API_VERSION }areas_demarcadas`, params);
    },

    save: function(drawPolygon) {
      const result = DrawPolygonsObjectService.convertToSend(drawPolygon);
      return result.id ? this.sendUpdate(result) : this.send(result);
    },

    toggleCarregarAutomaticamente: function(drawPolygon) {
      return this.sendUpdate({
        id: drawPolygon.id,
        carregar_automaticamente: drawPolygon.carregar_automaticamente ? 'N' : 'S'
      });
    },

    send: function(drawPolygon) {
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION }areas_demarcadas`,
        data: { areas: [drawPolygon] }
      });
    },

    sendUpdate: function(drawPolygon) {
      return $http({
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION }areas_demarcadas/${ drawPolygon.id}`,
        data: { area_demarcada: drawPolygon }
      });
    },

    delete: function(id) {
      return $http.delete(`${SERVER + API_VERSION }areas_demarcadas/${ id}`);
    },

    get: function(id) {
      const filters = { complete: true };
      return $http.get(`${SERVER + API_VERSION }areas_demarcadas/${ id}`, { params: filters });
    },

    tipos: function() {
      return $http.get(`${SERVER + API_VERSION }areas_demarcadas/tipos`);
    },

    getKmlContent: function(id) {
      return $http.get(`${SERVER}v1/areas_demarcadas/${id}/transform_to_kml`);
    },

    getLinkKml: function(id, token) {
      return (`${SERVER + API_VERSION }areas_demarcadas/${ id }/transform_to_kml?token=${ token}`);
    }

  };
});
